'use strict'

Vue.component('awe-age-gate-modal', {
  props: {
    ageGateFloor: {type: Number, default: 16},
  },
  data() {
    return {
      i18n: window.i18n,
      showModal: false,
      onlineModal: false,
      offlineModal: false,
      modalType: '',
      avail: {},
      dob: undefined,
      userMeetsAgeReqs: undefined,
      targetUrl: '',
      storageKeys:{
        UNDERAGE: 'isUserUnderage',
        EXPIRATION: 'isUserUnderageExpiration',
      },
      storageTTL: 2 * 3600 * 1e3 // 2 hours
    };
  },
  computed: {
    isUserUnderage: function() {
      const underAgeUser = this.userMeetsAgeReqs === false;
      return underAgeUser;
    }
  },
  methods: {
    show: async function(type, avail, targetUrl) {
      switch (type) {
        case 'offline':
          this.offlineModal = true
          this.onlineModal = false
          break
        case 'buy':
        case 'tos':
        case 'directions':
        default:
          this.offlineModal = false
          this.onlineModal = true
      }

      this.modalType = type
      this.avail = avail;
      this.targetUrl = targetUrl;

      // check to see if age data is stored in local storage
      const savedValue = localStorage.getItem(this.storageKeys.UNDERAGE)
      if (savedValue !== null){
        const isUnderage = savedValue === 'true'
 
        // if isUserUnderage exists, check expiration time
        const expirationValue = localStorage.getItem(this.storageKeys.EXPIRATION)
        let expirationTime = 0
        if (expirationValue != null){
          expirationTime = +expirationValue;
        }
        const currentTime = new Date().getTime();

        // if value is unreadable or the expiration time has passed, remove the data from local storage
        if (isNaN(expirationTime) || currentTime > expirationTime) {
          localStorage.removeItem(this.storageKeys.UNDERAGE);
          localStorage.removeItem(this.storageKeys.EXPIRATION);
        }
        else
          // if the expiration time has not passed, set the value of isUserUnderage to the value stored in local storage
          this.userMeetsAgeReqs = !isUnderage;
      }

      // the user only needs to input their DOB once
      // if they meet the age requirement we do not need to show them the offlineModal again
      if (this.userMeetsAgeReqs && !this.showModal && this.offlineModal) {
        this.showModal = false;
        this.offlineModal = false;
        this.continueToOfflineView(false);
        return;
      } else if (this.isUserUnderage && this.offlineModal) {
        this.offlineModal = false;
      }

      this.showModal = true;
      
      await this.expandModal();

    },
    expandModal: async function() {
      // saves the current height and width to app.$data._iframeSize
      await app.getIframeSize()

      // if the iframe is smaller than 350px, resize iframe to accomodate modal
      if (app.$data._iframeSize.height < 350) {
        hostCom.send('awe:resize', {height: '350px'})
      }

      // activate the full screen cloak div
      hostCom.send('awe:toggleCloak')
      hostCom.send('awe:toggleScroll', {force: true})
      },
    closeModal: function() {
      const defaultHeight = app.$data._iframeSize.height;
      
      this.showModal = false;
      this.offlineModal = false;
      this.onlineModal = false;

      // reset the height of the widget to it's original dimensions
      hostCom.send('awe:resize', {height: defaultHeight})

      // remove full screen cloak div
      hostCom.send('awe:toggleCloak')
      hostCom.send('awe:toggleScroll', {force: false})
    },
    continueToBuy: function(event) {
      this.closeModal()
      if (this.targetUrl)
        window.open(this.targetUrl, '_blank')
      else
        this.$emit('age-gate-validated', 'online', this.avail, event)
        if(this.modalType === 'buy' || this.modalType === 'tos') {
          Tracker.dropTag('age-gate-redirect-continue', {continueSrc: this.modalType})
        }
    },
    getAge: function() {
      // make sure that all fields are filled out
      if (!this.dob) {
        return;
      }

    // YYYY/MM/DD date format
    const dobTime = new Date(this.dob)

      // if the date is valid, we compare with cutoff date (current date - age gate floor)
      // build YYYY-MM-DD strings and simple comparison.
      const cutoff = new Date();
      cutoff.setFullYear(cutoff.getFullYear() - this.ageGateFloor)
      cutoff.setHours(0,0,0,0)
      const isAllowed = dobTime <= cutoff

      this.validateDOB(isAllowed)    
    },
    validateDOB: function(passesAgeGate) {
      this.userMeetsAgeReqs = passesAgeGate

      if (passesAgeGate){
        this.continueToOfflineView(true)
      }else{
        this.userMeetsAgeReqs = false;
        this.offlineModal = false;
        Tracker.dropTag('age-gate-fail')
      }
      // save result for 2 hours
      const expirationTime = new Date().getTime() + this.storageTTL

      try{
        localStorage.setItem(this.storageKeys.UNDERAGE, (!this.userMeetsAgeReqs).toString())
        localStorage.setItem(this.storageKeys.EXPIRATION, expirationTime.toString());
      }
      catch(ex){ /* unimportant, swallow error */ }
    },
    continueToOfflineView: function (modalOpen) {
      if (modalOpen) {
        this.closeModal();
      }
      // emit event to show offline stores
      this.$emit('age-gate-validated', 'offline')
    },
    cancelBtnClkHandler: function () {
      if(this.onlineModal) {
        Tracker.dropTag('age-gate-redirect-cancel', {cancelSrc: this.modalType})
      } else {
        Tracker.dropTag('age-gate-cancel')
      }
      this.closeModal()
      this.$emit('age-gate-cancelled', this.modalType, this.avail)
    }
  },
  template: `
    <div class="age-gate-modal" v-show="this.showModal">  
        <button class="close-button" @click="cancelBtnClkHandler">×</button>
        <div class="modal-mask-ctnr">
          <div class="modal-content">
            <slot name="header"></slot>
            <div class="message-container">
              <div v-if="this.onlineModal">
                {{i18n.getString('AGE_GATE_REDIRECT')}}
              </div>
              <div v-if="this.offlineModal && !isUserUnderage" class="offline-modal">
                {{i18n.getString('AGE_GATE_DOB_REQUEST')}}
                <form class="dob-input-container" v-on:keypress.enter="getAge">
                  <input type="date" v-model="dob" class="date-picker"
                    min="1900-01-01" :max="(new Date().toISOString().split('T')[0])" name="dob" >
                </form>
              </div>
              <div v-if="isUserUnderage && !this.onlineModal">
                {{i18n.getString('AGE_GATE_UNDERAGE_MESSAGE')}}
              </div>
            </div>
            <div class="button-container">
              <button v-if="isUserUnderage && !this.onlineModal" class="button close-modal-button close" v-on:click="cancelBtnClkHandler">
                {{i18n.getString('AGE_GATE_CLOSE')}}
              </button>
              <button v-if="!isUserUnderage || this.onlineModal" class="button cancel-button" v-on:click="cancelBtnClkHandler">
                {{i18n.getString('AGE_GATE_CANCEL')}}
              </button>
              <button v-if="this.onlineModal" class="button continue-button" v-on:click="continueToBuy">
                {{i18n.getString('AGE_GATE_CONTINUE')}}
              </button>
              <button v-if="this.offlineModal && !isUserUnderage" class="button continue-button" v-on:click="getAge">
                {{i18n.getString('AGE_GATE_SUBMIT')}}
              </button>
            </div>
            <span v-show="isUserUnderage && !this.onlineModal">
              <slot name="age-fail-footer"></slot>
            </span>
          </div>
        </div>
    </div>
  `
})
